import { z } from "zod";

export const publicAiTriageSchema = z.object({
  clinicId: z.string().uuid(),
  patientText: z
    .string()
    .trim()
    .min(10, "Describe el motivo de consulta con algo más de detalle")
    .max(800, "El motivo de consulta no puede superar 800 caracteres"),
});
